/* eslint-disable no-sequences */
import axios from "axios";
import { apiToken, apiUrl_forShipping } from "./constants";
const CancelToken = axios.CancelToken;

// get shippings
export let cancelGetShippingsApi;
export async function getShippings(token) {
    if (token) {
        const shippings = await axios.get(
            apiUrl_forShipping + "getFedexshipping",
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetShippingsApi = c;
                }),
            }
        );
        return shippings;
    } else {
        console.log("Please add required parameters");
    }
}
// get services
export let cancelGetServicesApi;
export async function getServices(token) {
    if (token) {
        const services = await axios.get(
            apiUrl_forShipping + "shipping/services",
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetServicesApi = c;
                }),
            }
        );
        return services;
    } else {
        console.log("Please add required parameters");
    }
}

// get shippings detail
export let cancelGetShippingDetailsApi;
export async function getShippingDetails(token, id) {
    if (token && id) {
        const shippingData = await axios.get(
            apiUrl_forShipping + "fedexshipping/edit/" + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetShippingDetailsApi = c;
                }),
            }
        );
        return shippingData;
    } else {
        console.log("Please add required parameters");
    }
}

// add shipping
export let cancelAddShippingApi;
export async function addShipping(token, shippingData) {
    if ((token, shippingData)) {
        const shipping = await axios.post(
            apiUrl_forShipping + "fedexshipping",
            shippingData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddShippingApi = c;
                }),
            }
        );
        return shipping;
    } else {
        console.log("Please add required parameters");
    }
}

// add shipping
export let cancelSortShippingApi;
export async function sortShipping(token, shippingData) {
    if ((token, shippingData)) {
        const shippings = await axios.post(
            apiUrl_forShipping + "shipping/sort",
            shippingData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelSortShippingApi = c;
                }),
            }
        );
        return shippings;
    } else {
        console.log("Please add required parameters");
    }
}

// edit shipping
export let cancelEditShippingApi;
export async function editShipping(token, shippingData) {
    if ((token, shippingData)) {
        const shippings = await axios.post(
            apiUrl_forShipping + "fedexshipping/edit/" + shippingData.id,
            shippingData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelEditShippingApi = c;
                }),
            }
        );
        return shippings;
    } else {
        console.log("Please add required parameters");
    }
}

// // update vendors
// export let cancelEditVendorApi;
// export async function editVendor(token, vendorData) {
//     if (token, vendorData) {
//         const vendors = await axios.put(apiUrl_forVendors + "vendor/" + vendorData.vendor_id,
//             vendorData,
//             {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                    "Api-Token": apiToken,
                    //"Access-Token": "",
//                 },
//             },
//             {
//                 cancelToken: new CancelToken(function executor(c) {
//                     cancelEditVendorApi = c;
//                 }),
//             }
//         );
//         return vendors;
//     } else {
//         console.log("Please add required parameters");
//     }
// }

// delete vendors
export let cancelDeleteShippingApi;
export async function deleteShipping(token, id) {
    if (token && id) {
        const shipping = await axios.get(
            apiUrl_forShipping + "/shipping/delete/" + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteShippingApi = c;
                }),
            }
        );
        return shipping;
    } else {
        console.log("Please add required parameters");
    }
}
